import Typography from '@mui/material/Typography';

export default function MainFooter(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" className='py-2 text-small'>
        {'Copyright © 2023 Coke Backend Crew Management. All Rights Reserved '}
        </Typography>
    );
}
